<template>
  <div class="field flex min-w-0 gap-3 px-3 py-2.5">
    <dt class="text-subtle break-words sm:w-[20rem] sm:shrink-0">{{ label }}:</dt>
    <dd class="min-w-0 flex-1 break-words">
      <slot />
    </dd>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string
}>()
</script>

<style scoped lang="scss">
.field {
  background-color: var(--color-canvas-default);
}
</style>
